import { useSelector } from 'react-redux';

import { RootState } from 'app/appStore';

export const useTrans = () => {
	const { trans } = useSelector((s: RootState) => s.commonSlice);
	return trans;
};
